import MainLayout from '@/components/layout/MainLayout.vue';
import { required, sameAs } from 'vuelidate/lib/validators';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import axios from "axios";
import { mapGetters } from "vuex";
import RegionJson from '@/assets/json/region.json';
import TwspNameJson from "@/assets/json/township.json";
import { fetchNotificationCount } from "@/services/common/notification-service";

export default {
    name: "editClass",

    components: {
        MainLayout,
        DatePicker,
    },

    data() {
        return {
            updateClassForm: {
                course_id: '',
                course_title: '',
                fee: '',
                start_time: '',
                end_time: '',
                start_date: '',
                end_date: '',
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
                monday1: false,
                tuesday1: false,
                wednesday1: false,
                thursday1: false,
                friday1: false,
                saturday1: false,
                sunday1: false,
                class_type: 0,
                // checkedDay: [],
                access_type: '',
                access_options: '',
                access_expiry_duration: '',
                region: '',
                town: ''
            },
            // Show/Hide fields based on conditions
            showAccessFields: {
                access_type: false,
                access_options: false,
                access_expiry_duration: false
            },
            courses: [],
            submitted: false,
            time_invalid_error: false,
            time_equal_error: false,
            date_invalid_error: false,
            submit_permission: false,
            weekend_validation: false,
            weekday_validation: false,
            weekdayweekend_validation: false,
            disabled: 0,
            disabledFee: 0,
            timePickerOptions: {
                start: "00:00",
                step: "00:15",
                end: "23:45"
            },
            regionArr: RegionJson,
            twspNameJson: TwspNameJson,
            selectedTwspName: "",
            twspName: [],
            disabledBtn: false,
            isShowExpDuration: false,
            isShowAccessOptions: false,
        }
    },

    validations: {
        updateClassForm: {
            start_time: {
                required
            },
            end_time: {
                required,
                notEqualTime: sameAs("start_time")
            },
            start_date: {
                required
            },
            end_date: {
                required
            },
        }
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        checkWeekend() {
            this.updateClassForm.monday = false;
            this.updateClassForm.tuesday = false;
            this.updateClassForm.wednesday = false;
            this.updateClassForm.thursday = false;
            this.updateClassForm.friday = false;
            this.updateClassForm.monday1 = false;
            this.updateClassForm.tuesday1 = false;
            this.updateClassForm.wednesday1 = false;
            this.updateClassForm.thursday1 = false;
            this.updateClassForm.friday1 = false;
            this.updateClassForm.saturday1 = false;
            this.updateClassForm.sunday1 = false;
            if (this.updateClassForm.saturday == false && this.updateClassForm.sunday == false) {
                this.weekend_validation = true;
            } else {
                this.weekend_validation = false;
                this.weekdayweekend_validation = false;
            }
        },

        checkWeekday() {
            this.updateClassForm.saturday = false;
            this.updateClassForm.sunday = false;
            this.updateClassForm.monday1 = false;
            this.updateClassForm.tuesday1 = false;
            this.updateClassForm.wednesday1 = false;
            this.updateClassForm.thursday1 = false;
            this.updateClassForm.friday1 = false;
            this.updateClassForm.saturday1 = false;
            this.updateClassForm.sunday1 = false;
            if (this.updateClassForm.monday == false && this.updateClassForm.tuesday == false && this.updateClassForm.wednesday == false &&
                this.updateClassForm.thursday == false && this.updateClassForm.friday == false) {
                this.weekday_validation = true;
            } else {
                this.weekday_validation = false;
                this.weekdayweekend_validation = false;
            }
        },

        checkWeekdayWeekend() {
            this.updateClassForm.monday = false;
            this.updateClassForm.tuesday = false;
            this.updateClassForm.wednesday = false;
            this.updateClassForm.thursday = false;
            this.updateClassForm.friday = false;
            this.updateClassForm.saturday = false;
            this.updateClassForm.sunday = false;
            if (this.updateClassForm.monday1 == false && this.updateClassForm.tuesday1 == false && this.updateClassForm.wednesday1 == false &&
                this.updateClassForm.thursday1 == false && this.updateClassForm.friday1 == false && this.updateClassForm.saturday1 == false &&
                this.updateClassForm.sunday1 == false) {
                this.weekdayweekend_validation = true;
            } else {
                this.weekday_validation = false;
                this.weekday_validation = false;
            }
        },

        time_check() {
            var start_time = moment(this.updateClassForm.start_time, "h:mm A").format("HH:mm")
            var end_time = moment(this.updateClassForm.end_time, "h:mm A").format("HH:mm")

            if (end_time < start_time) {
                this.time_invalid_error = true
            } else {
                this.time_invalid_error = false
            }

            if (end_time == start_time) {
                this.time_equal_error = true
            } else {
                this.time_equal_error = false
            }
        },

        date_check() {
            var start_date = this.updateClassForm.start_date;
            var end_date = this.updateClassForm.end_date;

            if (end_date < start_date) {
                this.date_invalid_error = true
            } else {
                this.date_invalid_error = false
            }
        },

        onChange(event) {
            var optionValue = event.target.value;
            var optionText = event.target.options[event.target.options.selectedIndex].text; 
            this.updateClassForm.course_id = optionValue;
            this.updateClassForm.course_title = optionText;
        },

        notBeforeToday(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
        },

        customFormatter(date) {
            return moment(date).format('HH:mm');
        },

        onRegionChange(event) {
            var Value = event.target.value;
            this.updateClassForm.region = Value;
            this.selectedTwspName = "";
            this.updateClassForm.town = "";
            this.twspName = this.changeTwspName(Value);
        },

        changeTwspName(value, twspName) {
            twspName = this.twspNameJson[value];
            return twspName;
        },

        onChangeTwspName(event) {
            var Value = event.target.value;
            this.updateClassForm.town = Value;
        },

        submit() {
            if (this.updateClassForm.class_type == 1 && this.updateClassForm.saturday == false && this.updateClassForm.sunday == false) {
                this.weekend_validation = true;
            } else {
                this.weekend_validation = false;
            }

            if (this.updateClassForm.class_type == 2 && this.updateClassForm.monday == false && this.updateClassForm.tuesday == false &&
                this.updateClassForm.wednesday == false && this.updateClassForm.thursday == false && this.updateClassForm.friday == false) {
                this.weekday_validation = true;
            } else {
                this.weekday_validation = false;
            }

            if (this.updateClassForm.class_type == 3 && this.updateClassForm.monday1 == false && this.updateClassForm.tuesday1 == false &&
                this.updateClassForm.wednesday1 == false && this.updateClassForm.thursday1 == false && this.updateClassForm.friday1 == false &&
                this.updateClassForm.saturday1 == false && this.updateClassForm.sunday1 == false) {
                this.weekdayweekend_validation = true;
            } else {
                this.weekdayweekend_validation = false;
            }

            if (this.time_invalid_error == false && this.time_equal_error == false && this.date_invalid_error == false) {
                if (this.weekend_validation == false && this.weekday_validation == false && this.weekdayweekend_validation == false) {
                    this.submitted = true;
                    this.submit_permission = false;
                    this.weekend_validation = false;
                    this.weekday_validation = false;
                    this.weekdayweekend_validation = false;
                    this.updateClass();
                } else {
                    this.submitted = false;
                }
            } else {
                this.submit_permission = true;
            }
        },

        updateClass() {
            this.disabledBtn = true;

            // Validation Logic
            let validationErrors = [];

            if (!this.updateClassForm.access_type) {
                validationErrors.push("အသုံးပြုခွင့်အမျိုးအစားဖြည့်ရန်လိုအပ်ပါသည်။");
            }

            if (this.updateClassForm.access_type == '2' && !this.updateClassForm.access_options) {
                validationErrors.push("အသုံးပြုခွင့် သက်တမ်းရွေးချယ်ပါ။");
            }

            if (
                this.updateClassForm.access_type == '2' &&
                this.updateClassForm.access_options == '2' &&
                (!this.updateClassForm.access_expiry_duration)
            ) {
                validationErrors.push("သက်တမ်းကာလဖြည့်ရန်လိုအပ်ပါသည်။");
            }

            if (
                this.updateClassForm.access_type == '2' &&
                this.updateClassForm.access_options == '2' &&
                (this.updateClassForm.access_expiry_duration && (this.updateClassForm.access_expiry_duration > 120 || this.updateClassForm.access_expiry_duration <= 0))
            ) {
                validationErrors.push("သက်တမ်းကြာချိန်သည် 1 လမှ 120 လအတွင်းသာ ဖြစ်ရမည်။");
            }

            if (validationErrors.length > 0) {
                validationErrors.forEach((error) => {
                    this.$notification.error(error, {
                        timer: 3,
                        position: "bottomCenter",
                    });
                });
                this.disabledBtn = false;
                return;
            }

            const request =
            {
                fee: this.updateClassForm.fee,
                start_time: this.updateClassForm.start_time,
                end_time: this.updateClassForm.end_time,
                start_date: this.updateClassForm.start_date,
                end_date: this.updateClassForm.end_date,
                monday: this.updateClassForm.monday,
                tuesday: this.updateClassForm.tuesday,
                wednesday: this.updateClassForm.wednesday,
                thursday: this.updateClassForm.thursday,
                friday: this.updateClassForm.friday,
                saturday: this.updateClassForm.saturday,
                sunday: this.updateClassForm.sunday,
                class_type: this.updateClassForm.class_type,
                region: this.updateClassForm.region,
                town: this.updateClassForm.town,
                access_type: this.updateClassForm.access_type,
                access_options: this.updateClassForm.access_type == 2 ? this.updateClassForm.access_options : null,
                access_expiry_duration: this.updateClassForm.access_type ==2 && this.updateClassForm.access_options == 2 ? this.updateClassForm.access_expiry_duration : null,
            };

            axios.post("/my/class/" + this.$route.params.id + "/update", request)
                .then(() => {
                    this.$router.push({ name: "manageClass" });
                    this.$notification.success("Class updated successfully", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                })
                .catch((error) => {
                    this.disabledBtn = false;
                    if (error.response.status === 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.error("Update Class Error", error);
                });
        },

        onAccessTypeChange(event) {
            if (event.target.value == 1) {
                this.isShowExpDuration = false;
                this.isShowAccessOptions = false;
            } else if (event.target.value == 2) {
               
                this.isShowAccessOptions = true;
                if(this.isShowAccessOptions && this.updateClassForm.access_expiry_duration != null){
                    
                    this.isShowExpDuration = true;
                }
            }
        },

        onAccessOptionsChange(event) {
            if(event.target.value == 1){
                this.isShowExpDuration = false;
            }else if(event.target.value == 2){
                this.isShowExpDuration = true;
            }
        },

        getDetailClass() {
            axios.get("/class/updateDetail/" + this.$route.params.id)
                .then((response) => {
                    this.updateClassForm = response.data.class;
                    this.disabledFee = response.data.class.approve_std !== 0;

                    if(response.data.class.access_type == 2){
                        this.isShowExpDuration = true;
                        this.isShowAccessOptions = true;
                    }else{
                        this.isShowExpDuration = false;
                        this.isShowAccessOptions = false;
                    }

                    if (response.data.class.access_expiry_duration != null) {
                        this.isShowExpDuration = true;
                    } else {
                        this.isShowExpDuration = false;
                    }
                    // Update the visibility of the fields based on data
                    this.showAccessFields.access_type = this.updateClassForm.access_type !== null;
                    this.showAccessFields.access_expiry_duration = this.updateClassForm.access_expiry_duration != null && this.updateClassForm.access_type == '2';
                    if (this.updateClassForm.access_type == '2') {
                        if (this.updateClassForm.access_expiry_duration != null) {
                            this.updateClassForm.access_options = '2';
                        } else {
                            this.updateClassForm.access_options = '1';
                        }
                    }
                    this.showAccessFields.access_options = this.updateClassForm.access_options;
                    this.updateClassForm.access_type = response.data.class.access_type;
                    this.updateClassForm.access_expiry_duration = response.data.class.access_expiry_duration;
                    // console.log(this.updateClassForm);
                    if (response.data.class.class_type == 3) {
                        this.updateClassForm.monday1 = response.data.class.monday;
                        this.updateClassForm.tuesday1 = response.data.class.tuesday;
                        this.updateClassForm.wednesday1 = response.data.class.wednesday;
                        this.updateClassForm.thursday1 = response.data.class.thursday;
                        this.updateClassForm.friday1 = response.data.class.friday;
                        this.updateClassForm.saturday1 = response.data.class.saturday;
                        this.updateClassForm.sunday1 = response.data.class.sunday;
                        this.updateClassForm.monday = 0;
                        this.updateClassForm.tuesday = 0;
                        this.updateClassForm.wednesday = 0;
                        this.updateClassForm.thursday = 0;
                        this.updateClassForm.friday = 0;
                        this.updateClassForm.saturday = 0;
                        this.updateClassForm.sunday = 0;
                    }
                    this.updateClassForm.start_time = this.customFormatter(response.data.class.start_date + ' ' + response.data.class.start_time);
                    this.updateClassForm.end_time = this.customFormatter(response.data.class.end_date + ' ' + response.data.class.end_time);
                    this.twspName = this.changeTwspName(this.updateClassForm.region);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    if (error.response.status == 403) {
                        this.$router.push({ name: "forbidden"});
                    }
                    if (error.response.status == 404) {
                        this.$router.push({ name: "notFound" })
                    }
                    console.log("Class Detail API Error", error);
                });
        },

        getCoursesForClass() {
            // axios.get("course/class/" + this.teacherId)
            axios.get("teacher/" + this.teacherId + "/course/list")
                .then((response) => {
                    this.courses = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Class for Course List API error", error);
                });
        },

    },

    mounted() {
        this.getDetailClass();
        // this.getCoursesForClass();
        fetchNotificationCount();

        // $("#fee").on("keypress keyup blur", function (event) {
        //     $(this).val($(this).val().replace(/[^\d].+/, ""));
        //     if ((event.which < 48 || event.which > 57)) {
        //         event.preventDefault();
        //     }
        // });
    }
};
